<template>
  <el-dialog
    v-if="modalVisible /* prevent loading */"
    :visible.sync="modalVisible"
    title="Goalpilot Bugtracker"
    width="75%">
    <div>
      Describe the bug (=Checklist item in Bugtracker)
      <!-- Why not use el-input ? -->
      <inline-editable-text
        @change="saveBug($event)"
        :floating-buttons="false"
        placeholder='Enter new Bug'
        tooltip="Enter new Bug"
        ref="name-bug"
        style="border: 1px dashed"
        :resetOnUpdate="true">
      </inline-editable-text>

      <!-- TODO: Display planned vs used time here -->
      <h5 class="mt-4">Recent bugs</h5>
      <ul style="list-style-type: square">
        <li v-for="bug in rootItemsArrayFlat.slice(0,10)" :key="bug.name">
          {{bug.name}} <!-- {{bug.sortidx}} -->
        </li>
        <li>...</li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
import { BUGTRACKER_TARGET_TASK_IDS } from '@/features'

export default {
  data: () => ({
    modalVisible: false
  }),
  computed: {
    taskChecklistItems() {
      return this.$models.taskChecklistItem.with(BUGTRACKER_TARGET_TASK_IDS).subscribeList()
    },
    rootItemsArrayFlat() {
      if (this.taskChecklistItems.$readyAll) {
        return this.taskChecklistItems
          // .asArraySorted()
          // .items
          // .reverse()
          .itemsAsArray()
          .filter(item => item.parent === 0);
      } else {
        return []
      }
    }
  },
  methods: {
    showNewModal() {
      this.modalVisible = true;
      /*this.$nextTick(() => {
        if (this.$refs['name-bug']) {
          this.$refs['name-bug'].focus(true)
        }
      })*/
    },
    saveBug($event) {

      let sortidx = 100;
      if ( this.taskChecklistItems.$readyAll ) {
        let lastItem = this.rootItemsArrayFlat.slice(-1)[0]
        sortidx = lastItem ? lastItem.sortidx + 1 : 100;
      } else {
        // not ready
        console.warn("Task is not ready, can not get sortidx");
      }

      let newTaskItem = {
        parent:  0,
        name:    $event,
        sortidx: sortidx
      };

      console.log('saving new bug', newTaskItem)
      this.$models.taskChecklistItem
        .with( BUGTRACKER_TARGET_TASK_IDS )
        .add( newTaskItem )
        .then(() => {
          this.$notify.success({
            type: 'success',
            message: 'Bug reported successfully. Nice work!'
          });
        })
    },

    onResetForm() {
      this.timeslotCollectionId = null;
    },
  }
}
</script>
